function reduceByField<A, F extends keyof A>(
  itemsArray: readonly A[],
  field: F,
  func: (data: A) => A = (x) => x,
): Record<string, A> {
  return itemsArray.reduce(
    (all, item) => ({
      ...all,
      [item[field] as any]: func(item),
    }),
    {},
  );
}

export function reduceById<I, A extends { id: I }>(
  itemsArray: readonly A[],
  func: (obj: A) => A = (x) => x,
): Record<string, A> {
  return reduceByField(itemsArray, 'id', func);
}

export function typedKeys<T extends object>(o: T): Array<keyof T> {
  return Object.keys(o) as Array<keyof T>;
}
